import L from "leaflet";

export const MAP_CONFIG = {
  MIN_ZOOM: 4,
  MAX_ZOOM: 17,
  DEFAULT_CENTER: [-14.235, -51.925],
  DEFAULT_ZOOM: 5,
  ZOOM_SNAP: 0.01,
  ZOOM_DELTA: 0.01,
  MAX_BOUNDS_VISCOSITY: 1.0
};

export const BASEMAP_STYLE = "arcgis/imagery";

export const BRAZIL_BOUNDS = L.latLngBounds(L.latLng(-35.5, -75.0), L.latLng(6.0, -33.0));

export const getMapOptions = () => ({
  minZoom: MAP_CONFIG.MIN_ZOOM,
  maxZoom: MAP_CONFIG.MAX_ZOOM,
  maxBounds: BRAZIL_BOUNDS,
  maxBoundsViscosity: MAP_CONFIG.MAX_BOUNDS_VISCOSITY,
  zoomControl: false,
  worldCopyJump: false,
  preferCanvas: true,
  zoomAnimation: false,
  zoomSnap: MAP_CONFIG.ZOOM_SNAP,
  zoomDelta: MAP_CONFIG.ZOOM_DELTA
});

export const getBasemapOptions = apiKey => ({
  apikey: apiKey,
  version: 2,
  language: "pt-BR",
  preserveDrawingBuffer: true
});

export const ARCGIS_API_KEY = process.env.VUE_APP_ARCGIS_API_KEY || "";

export const CORES_SISTEMA = {
  ControlSoft: "#059467",
  SySafra: "#0a5adb"
};

export const MARKER_STYLE = {
  radius: 7,
  weight: 1,
  color: "#fff",
  fillOpacity: 0.7
};

export const MARKER_SELECTED_STYLE = {
  fillColor: "#ffd600",
  radius: 10,
  weight: 1,
  color: "#fff",
  fillOpacity: 1
};
